import React from 'react';
import './AboutUsPage.css';
import Image from "../../../assets/images/about_us_img.png";
import { useTranslation } from "react-i18next";


function PrivacyPolicyPage() {
    const { t } = useTranslation();
    return (
        <div className="about-us-page">
            <h1>{t('Privacy Policy')} </h1>
            <p><b>{t('Effective Date:')}</b> {t('MAY 2025')}</p>
            <p>{t('https://abougabal.gr (“we,” “our,” or “us”) values your privacy. This Privacy Policy explains how we collect, use, and protect information you provide when you visit our website at https://abougabal.gr (the “Site”).')}</p>
            <hr/>
            <p><b>1. {t('Information We Collect')}</b></p>
            <div>{t('We may collect the following types of information:')}</div>
            <ul>
                <li><b>{t('Personal Information')}</b> {t('(e.g., name, email address) — only when you voluntarily provide it via contact forms or email.')}</li>
                <li><b>{t('Non-Personal Information')}</b> — {t('such as browser type, IP address, pages visited, and other anonymous usage data through tools like Google Analytics or similar.')}</li>
            </ul>
            <hr />
            <p><b>2. {t('How We Use Your Information')}</b></p>
            <p>{t(' We use the information we collect to:')}</p>
            <ul>
                <li>{t('Respond to your inquiries or messages.')}</li>
                <li>{t('Improve our website’s performance and content.')}</li>
                <li>{t('Monitor and analyze trends and usage.')}</li>
            </ul>
            <p>{t('We do not sell, rent, or trade your personal information to third parties.')}</p>
            <hr />
            <p><b>3. {t(' Cookies and Tracking Technologies')}</b></p>
            <p>{t('We may use cookies or similar technologies to:')}</p>
            <ul>
                <li>{t('Enhance your user experience.')}</li>
                <li>{t('Collect usage data for analytics purposes.')}</li>
                <li>{t('Monitor and analyze trends and usage.')}</li>
            </ul>
            <p>{t('You can disable cookies through your browser settings.')}</p>
            <hr />
            <p><b>4. {t('Third-Party Services')}</b></p>
            <p>{t('We may use third-party tools (e.g., analytics providers, hosting services) which may collect anonymous information. These providers are governed by their own privacy policies.')}</p>
            <hr />
            <p><b>5. {t('Data Security')}</b></p>
            <p>{t('We take reasonable measures to protect the information you provide. However, no method of transmission over the internet or electronic storage is 100% secure.')}</p>
            <hr />
            <p><b>6. {t('Your Rights')}</b></p>
            <p>{t('You may:')}</p>
            <ul>
                <li>{t('Request access to the personal data we hold about you.')}</li>
                <li>{t('Ask us to correct or delete your information.')}</li>
            </ul>
            <p>{t('To exercise your rights, please contact us at abougabal.mm@gmail.com')}</p>
            <hr />
            <p><b>7. {t('Children’s Privacy')}</b></p>
            <p>{t('Our website is not intended for children under the age of 13. We do not knowingly collect personal data from children.')}</p>
            <hr />
            <p><b>8. {t('Changes to This Policy')}</b></p>
            <p>{t('We may update this Privacy Policy occasionally. Any changes will be posted on this page with a revised effective date.')}</p>
            <hr />
            <p><b>9. {t('Contact Us')}</b></p>
            <p>{t('If you have any questions about this Privacy Policy, please contact us at:')}</p>
            <p> 📧 abougabal.mm@gmail.com</p>
            <p>📍 Athens, Greece</p>
        </div>

    );
}

export default PrivacyPolicyPage;
